import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/client/lib/api-client'

export interface AiActionItem {
  priority: number
  action: string
  reason: string
  impact: 'high' | 'medium' | 'low'
}

export interface AiSummaryResponse {
  available: boolean
  items?: AiActionItem[]
}

export function useAiSummary(siteId: string) {
  return useQuery({
    queryKey: ['sites', siteId, 'ai-summary'],
    queryFn: () => apiClient.get<AiSummaryResponse>(`/api/sites/${siteId}/ai-summary`),
    enabled: !!siteId,
    staleTime: 60 * 60 * 1000, // 1hr client cache
  })
}
